import { ChangeDetectionStrategy, Component, inject, input, Signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  provideTellentNavigationController,
  provideTellentNavigationItems,
  TellentNavigationDataFacade,
  TellentNavigationRoutingService,
  TellentNavigationViewModelBuilder,
  TellentSettingsNavigationController,
} from '@core/tellent-logic';
import {
  injectTellentSettingsLeaveUrl,
  TellentClientHomepageID,
  TellentNavigationItem,
} from '@core/tellent-types';
import { toLazySignal } from '@core/tellent-util';

import { TELLENT_APP_SHELL_LAYOUT } from '../../tellent-app-shell/tellent-app-shell-constants';
import { TellentNavigationLinkComponent } from '../navigation-link/navigation-link.component';
import { TellentNavigationComponent } from '../navigation.component';

@Component({
  selector: 'tlc-settings-navigation',
  styleUrl: 'settings-navigation.component.less',
  templateUrl: 'settings-navigation.component.html',
  imports: [TellentNavigationComponent, TranslatePipe, TellentNavigationLinkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    provideTellentNavigationItems({
      useFactory: () =>
        <Signal<TellentNavigationItem[]>>(
          toLazySignal(inject(TellentNavigationDataFacade).navigationSettings$, {
            initialValue: [],
          })
        ),
    }),
    provideTellentNavigationController({ useClass: TellentSettingsNavigationController }),
    TellentNavigationViewModelBuilder,
  ],
  host: {
    '[style.width.px]': 'TELLENT_APP_SHELL_LAYOUT.sidebarExpandedWidth',
  },
})
export class TellentSettingsNavigationComponent {
  #routingSvc = inject(TellentNavigationRoutingService);
  #settingsLeaveUrl = injectTellentSettingsLeaveUrl({ optional: true });

  public readonly TELLENT_APP_SHELL_LAYOUT = TELLENT_APP_SHELL_LAYOUT;

  public walkthroughId = input<string>();

  public goToHome(event: MouseEvent) {
    if (!event.metaKey) event.preventDefault();

    if (this.#settingsLeaveUrl) {
      return this.#routingSvc.navigate(this.#settingsLeaveUrl);
    }

    const route = this.#routingSvc
      .recognizedRoutes()
      .find(route => route.id === TellentClientHomepageID);

    if (route) {
      this.#routingSvc.navigate(route?.buildPath());
    } else {
      console.warn(
        `[TellentClient] No homepage route recognized, provide it with tellentHomeRouteFactory`,
      );
    }
  }
}
